var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4986 7.31343C11.5763 7.25991 11.6399 7.18831 11.6838 7.10478C11.7277 7.02125 11.7506 6.9283 11.7506 6.83393C11.7506 6.73956 11.7277 6.64661 11.6838 6.56308C11.6399 6.47955 11.5763 6.40795 11.4986 6.35443L3.91525 1.10443C3.82778 1.04366 3.72534 1.00803 3.61904 1.00139C3.51274 0.994761 3.40666 1.01739 3.31231 1.06681C3.21797 1.11624 3.13898 1.19057 3.08392 1.28174C3.02886 1.37291 2.99983 1.47742 3 1.58393L3 12.0839C3.00044 12.1902 3.02984 12.2943 3.08503 12.3851C3.14022 12.4759 3.21912 12.55 3.31325 12.5993C3.40737 12.6486 3.51316 12.6713 3.61923 12.665C3.7253 12.6587 3.82764 12.6236 3.91525 12.5634L11.4986 7.31343Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.59cb7dd41c1d83ab509b10ed27c5d289.svg";
export { ForwardRef as ReactComponent };